<template>
	<header>
		<h1 class="sr-only">3-Column</h1>
	</header>
</template>
